import React from 'react';
import { useZendeskApi } from '@hooks/useZendeskApi';
import * as Styled from './styles';

export const ZendeskButton = () => {
  const [api, isLoaded] = useZendeskApi();

  if (!isLoaded) {
    return null;
  }

  return (
    <>
      <Styled.Button
        onClick={() => {
          api?.show();
        }}
      >
        <Styled.Icon width={40} height={40} />
      </Styled.Button>
    </>
  );
};
